import React from 'react';
import IMAGES from 'assets/images';
import storeManager from 'store/manager';
import { connect } from 'react-redux';
import useTranslation from 'modules/localization';
// Components
import Modal from 'components/modal';
// Types
import { RootState } from 'store/types';
import { ModalOrderModify } from 'store/slices/modal-slice/types';
import { orderService } from 'services';
import { OrderSides } from 'shared/symbol/constants';
import getDecimalCount from 'shared/utils/getDecimalCount';

interface Props {
    modalData: ModalOrderModify,
}

const OrderModifyModal = (props: Props) => {
    const [serviceAvailable, setServiceAvailable] = React.useState(true);
    const { t } = useTranslation();

    const orderData = props.modalData.data;
    const { orderId, symbol, orderSide, price, takeProfit, stopLoss, digit, frozenPrice = false} = orderData;
    
    const changeOrderData = (property: string, value: any) => {
        storeManager.modal.setOrderModify({
            ...props.modalData, 
            data: { 
                ...orderData,
                [property]: value 
            }
        })
    }

    const handleClose = () => storeManager.modal.setOrderModify({ visibility: false, data: null })

    const changeTakeProfit = (value: string) => getDecimalCount(value) <= digit? changeOrderData('takeProfit', value.replace(',', '.')) : null
    const changeStopLoss = (value: string) => getDecimalCount(value) <= digit? changeOrderData('stopLoss', value.replace(',', '.')) : null

    const handleSubmitClick = () => {
        if (!serviceAvailable) return;
        
        setServiceAvailable(false);
        orderService.provider.modify()
            .then(() => handleClose())
            .finally(() => setServiceAvailable(true));
    }
    
    return (
        <Modal title={t('ModifyOrder')} id="order-modify-modal" close={handleClose}>
            <form onSubmit={(e) => e.preventDefault()}>
                <div className="symbol">
                    <span>{symbol}</span>
                </div>
                <div className="description">
                    #{orderId} {orderSide}
                </div>
                <div className="price">
                    <label htmlFor="modify-price">{t('Price')}</label>
                    <input id="modify-price" type="number" placeholder={price} value={!frozenPrice? price : undefined} readOnly={frozenPrice} onChange={!frozenPrice?((e) => changeOrderData('price', e.currentTarget.value)) : undefined} />
                </div>    
                <div className="takeprofit-stoploss">
                    <div className={'col' + (orderSide?.indexOf(OrderSides.SELL) !== -1? ' flex-end' : '')}>
                        <label htmlFor="modify-take-profit" className="take-profit-label">{t('TakeProfit')}</label>
                        <input id="modify-take-profit" type="text" value={takeProfit} onChange={(e) => changeTakeProfit(e.target.value)} />
                    </div>
                    <div className="col mid-col">
                        <img src={orderSide?.indexOf(OrderSides.SELL) !== -1? IMAGES.ICON.TPSL_SELL : IMAGES.ICON.TPSL_BUY} alt="" />
                    </div>
                    <div className={'col' + (orderSide?.indexOf(OrderSides.BUY) !== -1? ' flex-end' : '')}>
                        <label htmlFor="modify-stop-loss" className="stop-loss-label">{t('StopLoss')}</label>
                        <input id="modify-stop-loss" type="text" value={stopLoss} onChange={(e) => changeStopLoss(e.target.value)} />
                    </div>
                </div>        
                <button type="submit" className="submit-button" disabled={!serviceAvailable} onClick={handleSubmitClick}>
                    {
                        serviceAvailable? 
                            t('Modify') : <React.Fragment>{t('Loading')} <i className="icofont-spinner"></i></React.Fragment>
                    }
                </button>
            </form>
        </Modal>
    )
}

const mapStateToProps = (state: RootState) => ({
    modalData: state.modal.orderModify
})

export default connect(mapStateToProps)(OrderModifyModal);